/**
 * List endpoints often return either a plain array or a Paginated wrapper `{ data: T[] }`.
 */
export function unwrapListData<T>(body: T[] | { data?: T[] } | null | undefined): T[] {
  if (!body) {
    return [];
  }
  if (Array.isArray(body)) {
    return body;
  }
  if (typeof body === 'object' && Array.isArray((body as { data?: T[] }).data)) {
    return (body as { data: T[] }).data;
  }
  return [];
}
